import React, {ReactNode} from 'react';
import {Modal, ModalBody, ModalContent, ModalHeader} from "@heroui/react";

interface ConfirmationModalProps {
    isOpen: boolean;
    onOpenChange: (isOpen: boolean) => void;
    title?: string;
    children: ReactNode | ((onClose: () => void) => ReactNode);
    size?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl";
    placement?: "center" | "top" | "bottom";
    closeButton?: boolean;
}

const ConfirmationModal :React.FC<ConfirmationModalProps> = ({isOpen, onOpenChange, title, children, size = "md", placement = "center", closeButton = true,}) => {
    return (
        <Modal
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            size={size}
            placement={placement}
            closeButton={closeButton}
            isDismissable={false}
            isKeyboardDismissDisabled={false}
            hideCloseButton
        >
            <ModalContent className="p-3">
                {(onClose) => (
                    <>
                        {title && (
                            <ModalHeader className="text-center text-xl font-semibold text-gray-900">
                                {title}
                            </ModalHeader>
                        )}
                        <ModalBody>
                            {typeof children === 'function' ? children(onClose) : children}
                        </ModalBody>
                    </>
                )}
            </ModalContent>
        </Modal>
    );
};

export default ConfirmationModal;
